import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { pospHubApi, type CoverPreference } from '@/services/pospHub';

const PREFERENCES_KEY = ['posp-hub', 'preferences'] as const;

export function useCoverPreference() {
  return useQuery({ queryKey: PREFERENCES_KEY, queryFn: () => pospHubApi.getPreferences() });
}

export function useSetCoverPreference() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (value: CoverPreference) => pospHubApi.setCoverPreference(value),
    // The radio shows what the SERVER stored, not what was clicked.
    onSuccess: (saved) => queryClient.setQueryData(PREFERENCES_KEY, saved),
  });
}

export function useQuoteXp(quoteRequestId?: string) {
  return useQuery({
    queryKey: ['posp-hub', 'quote-xp', quoteRequestId],
    queryFn: () => pospHubApi.getQuoteXp(quoteRequestId as string),
    enabled: !!quoteRequestId,
    staleTime: 60_000,
  });
}
